import React, { useState, useEffect, useRef } from "react";
import AuthChoice from "../../components/AuthChoice";
import AuthDetailForm from "../../components/AuthDetailForm";
import { makePost } from "../../utils/fetchUtils";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { SEND_OTP, SIGNUP, VALIDATE_OTP } from "../../utils/constants";
import { setTimeout } from "timers/promises";
import { ErrorObj } from "../../utils/types";
import nclude from "../../assets/nclude.svg";
import sticker1 from "../../assets/sticker1.svg";
import curve1 from "../../assets/curve.svg";
import woman1 from "../../assets/woman1.png";
import greaterThan from "../../assets/greaterthan.svg";

export type AuthChoiceType = "user" | "org" | "choice";

const Signup = () => {
  useEffect(() => {
    if (localStorage.getItem("token")) {
      navigate("/");
    }
    document.title = "Signup - Nclude Portal";
  }, []);

  const navigate = useNavigate();

  const mainRef = useRef<HTMLInputElement>(null);
    const location = useLocation();

  const [authChoice, setAuthChoice] = useState<AuthChoiceType>("user");
  const [userName, setUserName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [isOtpMatched, setIsOtpMatched] = useState(false);

  //0 - not verified , 1 - verification failed , 2 - verification successful
  const [emailVerified, setEmailVerified] = useState<0 | 1 | 2>(0);
  const [phoneVerified, setPhoneVerified] = useState<0 | 1 | 2>(0);

  const [password, setPassword] = useState("");
  // const [error,setError] = useState('');
  const [requestAccessLink, setRequestAccessLink] = useState(false);
  const [verifyError, setVerifyError] = useState("");
  const [error, setError] = useState<ErrorObj>({
    email: "",
    password: "",
    phone: "",
    system: "",
    confirmPassword: "",
  });

  const handleOtpValidation = async (choice: any) => {
    setVerifyError("");
    try {
      const body = {
        otp: otp,
        phoneNumber: phoneNumber,
        email: email,
      };
      if (choice === "phone") {
        body.email = "";
      } else {
        body.phoneNumber = "";
      }
      console.log(body);
      const response = await makePost(VALIDATE_OTP, JSON.stringify(body));
      // console.log(response);
      if (response.success === true) {
        setIsOtpMatched(true);
        setOtpSent(false);
        if (choice === "phone") {
          setPhoneVerified(2);
        } else {
          setEmailVerified(2);
        }
        setError({});
      } else {
        setIsOtpMatched(false);
        setOtpSent(false);
        if (choice === "phone") {
          setPhoneVerified(0);
        } else {
          setEmailVerified(0);
        }
      }
      console.log(response);
    } catch (error: any) {
      setError({});
      if (error.response && error.response.data) {
        setVerifyError(error.response.data.message);
      }
      setIsOtpMatched(false);
      setOtpSent(false);
      console.log(error);
      if (choice === "phone") {
        setPhoneVerified(0);
      } else {
        setEmailVerified(0);
      }
      // console.log(error);
    }
  };

  const handleSendOtp = async (choice: any) => {
    try {
      const body = {
        email: email,
        phoneNumber: phoneNumber,
        userType: authChoice,
      };
      if (choice === "phone") {
        body.email = "";
      } else {
        body.phoneNumber = "";
      }
      const resp = await makePost(SEND_OTP, JSON.stringify(body));
      if (resp.success === true) {
        setOtpSent(true);
      } else {
        setError({
          system: resp.message,
        });
        // setError(resp.message);
      }
      // console.log(resp);
    } catch (error: any) {
      setError({});
      if (error.response && error.response.data) {
        if (error.response.status === 401) {
          setRequestAccessLink(true);
        } else
          setError({
            system: error.response.data.message,
          });
      }
      //  console.log("error : ",error);
    }
    setOtp("");
  };

  const phoneValidator = () => {
    setError({});
    if (phoneNumber.length !== 10) {
      setError({
        phone: "Enter valid 10 Digit Number",
      });
      return false;
    }
    if (!/^\d*$/.test(phoneNumber)) {
      setError({
        phone: "Please enter a valid phone number",
      });
      return false;
    }
    return true;
  };

  const emailValidator = () => {
    setError({});
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(email)) {
      setError({
        email: "Please enter a valid email address",
      });
      return false;
    }
    return true;
  };

  const handleSignup = async () => {
    setError({});
    if (phoneNumber && !phoneValidator()) {
      return;
    }
    if(email && !emailValidator()) {
      return;
    }
    if (!isOtpMatched) {
      setError({
        system: "Please verify email or passowrd",
      });
      return;
    }
    try {
      if (userName === "" || password === "") {
        setError({
          system: "Please Fill all the details",
        });
        return;
      }
      if (password.length < 8) {
        setError({
          password: "Minimum Length for password must be 8",
        });
        return;
      }
      // else if(phoneNumber.length!=10){
      //   setError("Enter Valid Phone Number");
      //   return;
      // }
      const body = {
        userName,
        phoneNumber,
        email,
        userType: authChoice,
        password,
      };

      const response = await makePost(SIGNUP, JSON.stringify(body));
      // console.log(response);
      if (response.success === true) {
        localStorage.setItem("token", response.token);
        localStorage.setItem("resume", "false");
        localStorage.setItem("scope", response.scope);
        localStorage.setItem("userId",response.userId);
        navigate("/");
      }
    } catch (error: any) {
      if (error.response && error.response.data) {
        if (error.response.status === 401) {
          setRequestAccessLink(true);
          setError({});
        } else
          setError({
            system: error.response.data.message,
          });
      }
      // console.log("error while signing : ",error);
    }
  };

  useEffect(() => {
      // Set focus on the main content when the route changes
      if (mainRef.current) {
        mainRef.current.focus();
      }
    }, [location]);

  return (
    <div className="auth-page flex justify-content-center login-form" role="main">
      <div className="logo-container">
        <div className="flex justify-center items-center h-screen w-full">
          <div className="flex flex-col items-start">
            <img src={nclude} alt="Nclude logo" className="logo mb-3" />
            <div className="flex flex-col items-start text-container">
              <img src={sticker1} alt="" aria-hidden="true" className="sticker1 mb-2" />
              <img src={curve1} alt="" aria-hidden="true" className="curve1 mb-4" />
                <h3 className="text-left font-normal">
                Resources <br />
                and opportunities for <span className="font-bold tracking-normal text-white">People with Disabilities</span>
                </h3>
            </div>
          </div>
        </div>
      </div>
      <div className="auth-form-container flex flex-col items-center">
        <div className="auth-form">
          <h1
            className="mt-12 mb-3 text-[2rem]"
            tabIndex={-1}
            ref={mainRef}
            style={{ fontWeight: 600, lineHeight: "2.375rem" }}
          >
            Welcome to Nclude Portal
          </h1>
          <h2
            className="text-[1.875rem]"
            style={{ color: "#787486", fontWeight: 500, fontSize: "1rem", lineHeight: '1.25rem' }}
          >
            Register your account in Nclude Portal <br />
            <span className="text-[#C117AB]" style={{ fontSize: '0.75rem'}} role="alert">*You need to either verify your email address or Phone number to register with Nclude</span>
          </h2>
          <div className="flex flex-col">
          {
          <>
            {authChoice === "choice" && (
              <AuthChoice
                authChoice={authChoice}
                setAuthChoice={setAuthChoice}
              />
            )}
            {authChoice !== "choice" && (
              <AuthDetailForm
                handleSendOtp={handleSendOtp}
                otp={otp}
                otpSent={otpSent}
                setOtp={setOtp}
                setOtpSent={setOtpSent}
                phoneNumber={phoneNumber}
                setPhoneNumber={setPhoneNumber}
                email={email}
                setEmail={setEmail}
                emailVerified={emailVerified}
                setEmailVerified={setEmailVerified}
                phoneVerified={phoneVerified}
                setPhoneVerified={setPhoneVerified}
                setUserName={setUserName}
                userName={userName}
                handleOtpValidation={handleOtpValidation}
                handleSignup={handleSignup}
                isOtpMatched={isOtpMatched}
                setIsOtpMatched={setIsOtpMatched}
                password={password}
                setPassword={setPassword}
                error={error}
                setError={setError}
                verifyError={verifyError}
                setVerifyError={setVerifyError}
                requestAccessLink={requestAccessLink}
              />
            )}
          </>
        }
          </div>
        </div>
      </div>
      {/* <div>
        <h1 className="my-12 text-[2.375rem] ">Welcome to Nclude Portal</h1>
        <h2 className="text-[24px] ">Register your account in Nclude Portal</h2>
        <h3 className="d-flex text-[18px] mt-4 w-[700px] ">
          You need to either verify your email address or Phone number to
          register with Nclude
        </h3>
        {
          <>
            {authChoice === "choice" && (
              <AuthChoice
                authChoice={authChoice}
                setAuthChoice={setAuthChoice}
              />
            )}
            {authChoice !== "choice" && (
              <AuthDetailForm
                handleSendOtp={handleSendOtp}
                otp={otp}
                otpSent={otpSent}
                setOtp={setOtp}
                setOtpSent={setOtpSent}
                phoneNumber={phoneNumber}
                setPhoneNumber={setPhoneNumber}
                email={email}
                setEmail={setEmail}
                emailVerified={emailVerified}
                setEmailVerified={setEmailVerified}
                phoneVerified={phoneVerified}
                setPhoneVerified={setPhoneVerified}
                setUserName={setUserName}
                userName={userName}
                handleOtpValidation={handleOtpValidation}
                handleSignup={handleSignup}
                isOtpMatched={isOtpMatched}
                setIsOtpMatched={setIsOtpMatched}
                password={password}
                setPassword={setPassword}
                error={error}
                setError={setError}
                verifyError={verifyError}
                setVerifyError={setVerifyError}
                requestAccessLink={requestAccessLink}
              />
            )}
          </>
        }
      </div> */}
    </div>
  );
};

export default Signup;
